import { ajax, DOMPurify } from '../../../../themes/ett-core-theme/assets/scripts/vendors';

const featureBlock = (function ($) {
  let loading = false;
  let totalPages = 1;
  const isAdmin = document.querySelector("body").classList.contains("wp-admin");
  const apiSrc = new URL(
    `${window.global.wordpress_base_url}/wp-json/ett_api_get/v1/byterms`
  );
  return {
    generateDomItem: function (element, blockItem) {
      let clone = document.createElement("div");
      clone.setAttribute("class", blockItem.getAttribute("class"));
      clone.innerHTML = blockItem.innerHTML;
      clone.classList.add(`grid-item-el-${element.ID}`);
      clone.classList.add(`${element.postType}`);
      let title = clone.querySelector(".slider-item-title");
      let links = [...clone.querySelectorAll(".content a")];
      let occhiello = clone.querySelector(".occhiello");
      let image = clone.querySelector(".image .image-thumb");
      if (occhiello && element.tags.length) {
        element.tags.forEach((tag) => {
          occhiello.innerHTML += `<span>${tag.name} </span>`;
        });
      }
      if (image && element.images.locandina.hasOwnProperty("url")) {
        image.setAttribute("src", element.images.locandina.url);
        image.setAttribute("width", element.images.locandina.width);
        image.setAttribute("height", element.images.locandina.height);
        image.setAttribute("alt", element.title);
        image.setAttribute("loading", "lazy");
      } else if (image && element.images.large.hasOwnProperty("url")) {
        image.setAttribute("src", element.images.large.url);
        image.setAttribute("width", element.images.large.width);
        image.setAttribute("height", element.images.large.height);
        image.setAttribute("alt", element.title);
        image.setAttribute("loading", "lazy");
      }
      if (!isAdmin) {
        links.forEach((a) => a.setAttribute("href", element.url));
      }
      title.innerHTML = element.title;
      return clone;
    },
    startSlider: function (container, options) {
      import(/* webpackChunkName: "tiny-slider" */"../../../../themes/ett-core-theme/node_modules/tiny-slider/src/tiny-slider")
        .then(({ tns }) => {
          let slider = tns({
            container: container,
            items: 1,
            slideBy: 'page',
            mode: "carousel",
            nav: true,
            controlsText: [
              '<span class="sr-only">Slide Precedente</span><i class="bi bi-chevron-left"></i>',
              '<span class="sr-only">Slide Successiva</span><i class="bi bi-chevron-right"></i>',
            ],
            controls: true,
            //mouseDrag: true,
            //swipeAngle: false,
            speed: 500,
            autoplayTimeout: 5000,
            autoplay: options.autoplay,
            autoplayButtonOutput: false,
            loop: true,
            onInit: (e) => {
              featureBlock.sliderInfo = e;
              container.classList.add('loaded');
            },
          });
        });

    },
    getItems: function (
      search,
      blockElement,
      itemTemplate,
      page,
      refresh,
      spinner,
      sliderOptions
    ) {
      return search.subscribe(
        (res) => {
          spinner.classList.remove("loading");
          blockElement.classList.remove("no-content");
          let list = res.response.list;
          totalPages = res.response.pager.tot_pages;
          loading = false;
          if (refresh || list.length === 0) {
            blockElement.innerHTML = "";
          }
          list.forEach((element) => {
            let domElement = this.generateDomItem(element, itemTemplate);
            blockElement.innerHTML += DOMPurify.sanitize(domElement.outerHTML);
          });
          featureBlock.startSlider(blockElement, sliderOptions);
        },
        (err) => {
          blockElement.innerHTML = "";
          blockElement.classList.add("no-content");
          spinner.classList.remove("loading");
          loading = false;
        }
      );
    },
    init: function (wrap) {
      let searchParams = new URLSearchParams(apiSrc.search.slice(1));
      let spinner;
      let block;
      let page = 1;
      let search = "";
      let cacheBurst = new Date();
      let originalSearchString = "";
      if (wrap instanceof jQuery) {
        block = wrap.find(".feature-slider")[0];
        spinner = wrap.find(".loading-spinner")[0];
      } else {
        block = wrap.querySelector(".feature-slider");
        spinner = wrap.querySelector(".loading-spinner");
      }
      let dataMax = block.getAttribute("data-max");
      let dataPosts = block.getAttribute("data-posts");
      let dataType = block.getAttribute("data-type");
      let dataCat = block.getAttribute("data-cat");
      let dataCurrentPost = block.getAttribute("data-current-post");
      let itemClasses = block.getAttribute("data-item-template");
      let autoplay = block.getAttribute("data-autostart") === 'true' ? true : false;
      let sliderOptions = {
        autoplay
      }
      let apiParam = {
        max: dataMax ? dataMax : "",
        posts: dataPosts ? dataPosts : "",
        type: dataType ? dataType : "",
        cat: dataCat ? dataCat : "",
        currentPost: dataCurrentPost ? dataCurrentPost : "",
      };
      let blockTemplate = document.createElement("div");
      blockTemplate.setAttribute("class", `slide ${itemClasses}`);
      blockTemplate.innerHTML = block.innerHTML;
      block.innerHTML = "";
      searchParams.append("terms", apiParam.cat);
      searchParams.append("type", apiParam.type);
      searchParams.append("posts", apiParam.posts);
      searchParams.append("per_page", apiParam.max);
      searchParams.append("paged", page);
      searchParams.append("ignore", apiParam.currentPost);
      searchParams.append("cacheburst", `${cacheBurst.getMinutes()}`);

      originalSearchString = `${apiSrc}?${searchParams}`;
      search = ajax(`${apiSrc}?${searchParams}`);

      spinner.classList.add("loading");
      const subscribe = featureBlock.getItems(
        search,
        block,
        blockTemplate,
        page,
        false,
        spinner,
        sliderOptions
      );
    }
  }
})(jQuery);

// document.addEventListener("DOMContentLoaded", () => {
//   const listWraps = [...document.querySelectorAll(".feature-block")];
//   if (listWraps) {
//     listWraps.forEach((wrap) => {
//       featureBlock.init(wrap);
//     });
//   }
// });
{
  const listWraps = [...document.querySelectorAll(".feature-block")];
  if (listWraps) {
    listWraps.forEach((wrap) => {
      featureBlock.init(wrap);
    });
  }
}
(function ($) {
  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=feature-block",
      featureBlock.init
    );
  }
})(jQuery);
export default featureBlock;